var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { greys } from "@irati/ui/src/global/colors";
import padding from "@irati/ui/src/global/padding";
import { Label3 } from "@irati/ui/src/Labels";
import Dot from "../Dot";
export var Container = styled(Label3).attrs({
    bold: true,
    uppercase: true
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  background-color: ", ";\n  padding: 5px 10px;\n  border-radius: ", ";\n  white-space: nowrap;\n  ", "\n"], ["\n  ", "\n  background-color: ", ";\n  padding: 5px 10px;\n  border-radius: ", ";\n  white-space: nowrap;\n  ", "\n"])), function (_a) {
    var center = _a.center;
    return center && "text-align: center;";
}, greys.light, padding.tiny, function (_a) {
    var margin = _a.margin;
    return margin && "margin: " + margin + ";";
});
export var StyledDot = styled(Dot)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 7px;\n"], ["\n  margin-left: 7px;\n"])));
var templateObject_1, templateObject_2;
